import { useState } from 'react';
import type { WhatsAppTemplateSendAction } from 'src/modules/shared/messaging/types/whatsapp-template-send.types';
import { normalizeWhatsAppPhoneNumber } from 'src/modules/shared/utils/formatting/whatsapp.util';
import type { TemplateReplyStatusOptions } from 'src/modules/communications/types/whatsapp/template-session-notice.types';

/**
 * Records successful sends without opening a WhatsApp response window.
 * @param options - Captured conversation identity and existing send action.
 * @returns A wrapped send and whether this exact context is waiting for a reply.
 * @throws Propagates send failures to the modal without setting a waiting state.
 */
export const useTemplateReplyStatus = ({
  sendTemplate,
  conversationId,
  fromAddress,
  toAddress,
  endTime,
}: TemplateReplyStatusOptions) => {
  const [lastSentContext, setLastSentContext] = useState<string>();
  const from = normalizeWhatsAppPhoneNumber(fromAddress ?? '');
  const to = normalizeWhatsAppPhoneNumber(toAddress ?? '');
  const context = JSON.stringify([conversationId, from, to, endTime]);
  const sendAndWaitForReply: WhatsAppTemplateSendAction = async (draft) => {
    await sendTemplate(draft);
    if (
      normalizeWhatsAppPhoneNumber(draft.fromPhoneNumber) === from &&
      normalizeWhatsAppPhoneNumber(draft.toPhoneNumber) === to
    ) {
      setLastSentContext(context);
    }
  };
  return { sendAndWaitForReply, waitingForReply: lastSentContext === context };
};
